<template>
<!--AlertMessage Component-->
   <AlertComponent v-if="defaultAlert.pageOrModal=='page'" :alertstatus="defaultAlert.alertstatus" :message="defaultAlert.alertMessage" :type="defaultAlert.alertType" />
   <!--End AlertMessage Component-->
   <!-- Loader -->
   <p v-show="tableData.isVisible" class="crud_table_loader_class">
       <img src="/img/loader2.gif" alt="Loading..." style="height: 80px;">
       <br>
       <span class="loading-message">
           {{ tableData.loaderMessage }}{{ tableData.loaderValue }}
       </span>
   </p>
   <!-- End Loader -->
   <!--Form Modal-->
   <!-- The Modal -->
   <div class="modal fade" id="myModal">
      <div class="modal-dialog">
         <div class="modal-content bg-sa-modal-content">
            <!-- Modal Header -->
            <!-- Modal body -->
            <div class="modal-body">
               <!--Forms-->
               <div class="card bg-sa-card">
                  <div class="card-header bg-sa-card-header d-flex justify-content-between align-items-center">
                     <span>Beautiful Form</span>
                     <button type="button" class="btn-close color-sa-btn-close" data-bs-dismiss="modal"></button>
                  </div>
                  <div class="card-body bg-sa-card-body m-0 p-1">
                     <form>
                        <!-- Row 1: Text & Email -->
                        <div class="row g-3 mb-0">
                           <div class="col-md-6">
                              <div class="mb-0 position-relative">
                                 <label for="myInput" class="form-label">First Name</label>
                                 <input type="text" id="myInput" class="form-control custom-tooltip-input" placeholder="Enter name">
                                 <div class="custom-tooltip">Please enter your first name <span class="tooltip-arrow"></span></div>
                              </div>
                           </div>
                           <div class="col-md-6">
                              <div class="mb-0 position-relative">
                                 <label for="myInput" class="form-label">Last Name</label>
                                 <input type="text" class="form-control custom-tooltip-input" id="lastnameInput" placeholder="Enter Last Name">
                                 <div class="custom-tooltip">Please enter your last name <span class="tooltip-arrow"></span></div>
                              </div>
                           </div>
                        </div>
                        <!-- Row 2: Password & Number -->
                        <div class="row g-3 mb-0">
                           <div class="col-md-6">
                              <div class="mb-0 position-relative">
                                 <label for="emailInput" class="form-label">Email</label>
                                 <input type="email" class="form-control custom-tooltip-input" id="emailInput" placeholder="Enter email">
                                 <div class="custom-tooltip">Please enter a valid email<span class="tooltip-arrow"></span></div>
                              </div>
                           </div>
                           <div class="col-md-6">
                              <div class="mb-0 position-relative">
                                 <label for="numberInput" class="form-label">Number</label>
                                 <input type="number" class="form-control custom-tooltip-input" id="numberInput" placeholder="Enter number">
                                 <div class="custom-tooltip">Enter your phone or ID number <span class="tooltip-arrow"></span></div>
                              </div>
                           </div>
                        </div>
                        <!-- Row 3: Select2 Single & Multi -->
                        <div class="row g-3 mb-0">
                           <div class="col-md-6">
                              <div class="mb-0 position-relative">
                                 <label for="websiteInput" class="form-label">Website</label>
                                 <input
                                    type="url"
                                    class="form-control custom-tooltip-input"
                                    id="websiteInput"
                                    placeholder="https://example.com"
                                    >
                                 <div class="custom-tooltip">
                                    Enter your website URL
                                    <span class="tooltip-arrow"></span>
                                 </div>
                              </div>
                           </div>
                           <div class="col-md-6">
                              <div class="mb-0 position-relative">
                                 <label for="sexInput" class="form-label">Sex</label>
                                 <select class="form-select form-select-lg select2 custom-tooltip-input" id="sexInput">
                                    <option value="" selected disabled>Select sex</option>
                                    <option value="male">Male</option>
                                    <option value="female">Female</option>
                                 </select>
                                 <div class="custom-tooltip">
                                    Select your sex
                                    <span class="tooltip-arrow"></span>
                                 </div>
                              </div>
                           </div>
                        </div>
                        <!-- Row 4: Fancy Checkboxes & Radios -->
                        <div class="row g-3 mb-0">
                           <div class="col-md-6">
                              <label class="form-label">Fancy Checkboxes</label>
                              <div class="d-flex align-items-center gap-4">
                                 <div class="form-check form-switch">
                                    <input class="form-check-input" type="checkbox" id="checkbox1">
                                    <label class="form-check-label" for="checkbox1">Check me</label>
                                 </div>
                                 <div class="form-check form-switch">
                                    <input class="form-check-input" type="checkbox" id="checkbox2">
                                    <label class="form-check-label" for="checkbox2">Another check</label>
                                 </div>
                              </div>
                           </div>
                           <div class="col-md-6">
                              <label class="form-label">Fancy Radio Buttons</label>
                              <div class="btn-group" role="group" aria-label="Radio group">
                                 <input type="radio" class="btn-check" name="radioGroup" id="radio1" autocomplete="off" checked>
                                 <label class="btn btn-outline-primary" for="radio1">Option 1</label>
                                 <input type="radio" class="btn-check" name="radioGroup" id="radio2" autocomplete="off">
                                 <label class="btn btn-outline-primary" for="radio2">Option 2</label>
                              </div>
                           </div>
                        </div>
                        <!-- Row 5: Textarea & File Upload -->
                        <div class="row g-3 mb-3">
                           <div class="col-md-6">
                              <label for="fileInput" class="form-label">File Upload</label>
                              <input class="form-control" type="file" id="fileInput">
                           </div>
                           <div class="col-md-6">
                              <label for="dateInput" class="form-label">Date</label>
                              <input type="date" class="form-control datepicker" id="dateInput">
                           </div>
                        </div>
                        <!-- Row 6: Dynamic Fields -->
                        <div class="row g-3 mb-3">
                           <div class="col-12">
                              <label class="form-label fw-bold">Dynamic Fields</label>
                              <!-- Container for dynamic rows -->
                              <div id="dynamicFieldsContainer">
                                 <!-- One dynamic row -->
                                 <div class="row g-2 align-items-end dynamic-row mb-2">
                                    <div class="col-md-4">
                                       <input type="text" name="dynamic[field1][]" class="form-control" placeholder="Field 1">
                                    </div>
                                    <div class="col-md-4">
                                       <input type="text" name="dynamic[field2][]" class="form-control" placeholder="Field 2">
                                    </div>
                                    <div class="col-md-3">
                                       <input type="text" name="dynamic[field3][]" class="form-control" placeholder="Field 3">
                                    </div>
                                    <div class="col-md-1 text-end">
                                       <button type="button" class="btn btn-danger btn-sm remove-row">
                                       <i class="fa fa-trash"></i>
                                       </button>
                                    </div>
                                 </div>
                              </div>
                              <!-- Add button -->
                              <button type="button" class="btn btn-outline-primary btn-sm mt-2" id="addDynamicRow">
                              <i class="fa fa-plus"></i> Add Row
                              </button>
                           </div>
                        </div>
                        <!-- Submit & Reset -->
                        <div class="row g-3 mt-4">
                           <div class="col-12 d-flex justify-content-end">
                              <button type="submit" class="btn btn-primary me-2">Submit</button>
                              <button type="reset" class="btn btn-secondary">Reset</button>
                           </div>
                        </div>
                     </form>
                  </div>
               </div>
               <!--End Forms-->
            </div>
            <!-- Modal footer -->
            <div class="modal-footer">
               <button type="button" class="btn btn-danger" data-bs-dismiss="modal">Close</button>
            </div>
         </div>
      </div>
   </div>
   <h1 class="sa-core-color">
      Dashboard
   </h1>
   <p class="sa-core-color">Nothing currently works here in dashboard! Work on it! The menus working are Crud Test, Subscription & others except dashboard!</p>
   <!--Tables-->
   <div class="card glass mt-0 bg-sa-card">
      <div class="card-body bg-sa-card-body p-0">
         <!-- Table action row -->
         <div class="d-flex flex-wrap justify-content-start align-items-center gap-1 p-1 bg-table-action-row">
            <!-- THIS is the key -->
            <div class="d-flex ms-auto gap-1">
               <button class="btn btn-success btn-sm" data-bs-toggle="modal" data-bs-target="#myModal">
               <i class="fa fa-plus"></i> Add
               </button>
               <button class="btn btn-secondary btn-sm">
               <i class="fa fa-upload"></i> Import
               </button>
               <!-- Export Dropdown -->
               <div class="btn-group btn-group-sm">
                  <button type="button" class="btn btn-secondary dropdown-toggle" data-bs-toggle="dropdown">
                  <i class="fa fa-download"></i> Export
                  </button>
                  <ul class="dropdown-menu">
                     <li><a class="dropdown-item" href="#"><i class="fa fa fa-file me-1 text-success"></i>Export XLS</a></li>
                     <li><a class="dropdown-item" href="#"><i class="fa fa fa-file-text me-1 text-success"></i>Export CSV</a></li>
                     <li><a class="dropdown-item" href="#"><i class="fa fa-file-pdf-o me-1 text-danger"></i>Export PDF</a></li>
                  </ul>
               </div>
               <!-- Reports Dropdown -->
               <div class="btn-group btn-group-sm">
                  <button type="button" class="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown">
                  Reports
                  </button>
                  <ul class="dropdown-menu">
                     <li><a class="dropdown-item" href="#">Data Report</a></li>
                     <li><a class="dropdown-item" href="#">Print</a></li>
                     <li><a class="dropdown-item" href="#">Filter Data</a></li>
                     <li><a class="dropdown-item" href="#">Search by Column</a></li>
                  </ul>
               </div>
               <div class="d-none d-md-block">
                  <button class="btn btn-collapse bg-transparent border-0">
                  <i class="fa fa-minus sa-table-action-color"></i>
                  </button>
                  <button class="btn btn-fullscreen bg-transparent border-0">
                  <i class="fa fa-expand sa-table-action-color"></i>
                  </button>
                  <button class="btn btn-delete bg-transparent border-0">
                  <i class="fa fa-times sa-table-action-color"></i>
                  </button>
               </div>
            </div>
         </div>
         <!-- Table Search Panel -->
         <div class="d-flex justify-content-between align-items-center p-1 flex-nowrap gap-2 bg-table-search-panel">
            <!-- Left: Search -->
            <div class="d-flex align-items-center gap-2">
               <div class="input-group">
                  <span class="input-group-text d-md-flex"><i class="fa fa-search"></i></span>
                  <input
                     type="search"
                     class="form-control form-control-sm"
                     id="tableSearch"
                     placeholder="Search...">
               </div>
            </div>
            <!-- Right: Entries select -->
            <div class="d-flex align-items-center gap-1">
               <select id="entriesSelect" class="form-select form-select-sm entries-select">
                  <option value="5">5</option>
                  <option value="10" selected>10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
               </select>
            </div>
         </div>
         <!-- Table -->
         <div class="table-responsive">
            <table class="table table-hover align-middle mb-0" id="bootstrapTable">
               <thead>
                  <tr>
                     <th width="40">
                        <input type="checkbox" id="selectAll">
                     </th>
                     <th>Name</th>
                     <th class="hide-sm-td">Email</th>
                     <th>Actions</th>
                  </tr>
               </thead>
               <tbody>
                  <!-- Row 1 -->
                  <tr class="main-row">
                     <td><input type="checkbox" class="row-check"></td>
                     <td
                        class="expand-cell"
                        data-bs-toggle="collapse"
                        data-bs-target="#tableDetails1"
                        aria-expanded="false"
                        >John Doe<i class="fa fa-plus text-success expand-icon ms-1"></i>
                     </td>
                     <td class="hide-sm-td">john@example.com</td>
                     <td class="p-0">
                        <div class="ps-3">
                           <button type="button" class="btn btn-secondary dropdown-toggle p-1" data-bs-toggle="dropdown">
                           Actions
                           </button>
                           <ul class="dropdown-menu">
                              <li><a class="dropdown-item" href="#"><i class="fa fa-edit me-1 text-primary"></i>Edit</a></li>
                              <li><a class="dropdown-item" href="#"><i class="fa fa-trash me-1 text-danger"></i>Delete</a></li>
                              <li><a class="dropdown-item" href="#"><i class="fa fa-eye me-1 text-info"></i>View</a></li>
                           </ul>
                        </div>
                     </td>
                  </tr>
                  <!-- Hidden expanded row -->
                  <tr class="collapse-row">
                     <td colspan="5" class="p-0">
                        <div id="tableDetails1" class="collapse table-collapse table-details">
                           <div class="p-3">
                              <strong class="show-sm-td">Email: doe@example.com</strong>
                              <strong>Role:</strong> Admin<br>
                              <strong>Status:</strong> Active<br>
                              <strong>Phone:</strong> +123456789<br>
                              <strong>Address:</strong> 123 Main Street
                           </div>
                        </div>
                     </td>
                  </tr>
                  <!-- Row 2 -->
                  <tr class="main-row">
                     <td><input type="checkbox" class="row-check"></td>
                     <td
                        class="expand-cell"
                        data-bs-toggle="collapse"
                        data-bs-target="#tableDetails2"
                        aria-expanded="false"
                        >John Doe<i class="fa fa-plus text-success expand-icon ms-1"></i>
                     </td>
                     <td class="hide-sm-td">jane@example.com</td>
                     <td class="p-0">
                        <div class="ps-3">
                           <button type="button" class="btn btn-secondary dropdown-toggle p-1" data-bs-toggle="dropdown">
                           Actions
                           </button>
                           <ul class="dropdown-menu">
                              <li><a class="dropdown-item" href="#"><i class="fa fa-edit me-1 text-primary"></i>Edit</a></li>
                              <li><a class="dropdown-item" href="#"><i class="fa fa-trash me-1 text-danger"></i>Delete</a></li>
                              <li><a class="dropdown-item" href="#"><i class="fa fa-eye me-1 text-info"></i>View</a></li>
                           </ul>
                        </div>
                     </td>
                  </tr>
                  <tr class="collapse-row">
                     <td colspan="5" class="p-0">
                        <div id="tableDetails2" class="collapse table-collapse table-details">
                           <div class="p-3">
                              <strong class="show-sm-td">Email: john@example.com</strong>
                              <strong>Role:</strong> Admin2<br>
                              <strong>Status:</strong> InActive<br>
                              <strong>Phone:</strong> +43234232<br>
                              <strong>Address:</strong> 427 Main Street
                           </div>
                        </div>
                     </td>
                  </tr>
               </tbody>
            </table>
         </div>
         <!-- Bottom Controls: Delete & Pagination -->
         <div class="d-flex justify-content-between align-items-center p-2 flex-wrap gap-2">
            <button class="btn btn-danger btn-sm" id="deleteSelected">
            <i class="fa fa-trash"></i> Delete Selected
            </button>
            <nav>
               <ul class="pagination pagination-sm mb-0" id="pagination"></ul>
            </nav>
         </div>
      </div>
   </div>
   <!--End Tables-->
   <!-- Dashboard Cards -->
   <div class="row g-3 mb-4 mt-1">
      <div class="col-6 col-md-6 col-lg-3">
         <div class="card bg-sa-card h-100">
            <div class="card-body bg-sa-card-body">
               <h5 class="card-title">Users</h5>
               <p class="card-text">150</p>
            </div>
         </div>
      </div>
      <div class="col-6 col-md-6 col-lg-3">
         <div class="card bg-sa-card h-100">
            <div class="card-body bg-sa-card-body">
               <h5 class="card-title">Sales</h5>
               <p class="card-text">$12,500</p>
            </div>
         </div>
      </div>
      <div class="col-6 col-md-6 col-lg-3">
         <div class="card bg-sa-card h-100">
            <div class="card-body bg-sa-card-body">
               <h5 class="card-title">Orders</h5>
               <p class="card-text">75</p>
            </div>
         </div>
      </div>
      <div class="col-6 col-md-6 col-lg-3">
         <div class="card bg-sa-card h-100">
            <div class="card-body bg-sa-card-body">
               <h5 class="card-title">Alerts</h5>
               <p class="card-text">5</p>
            </div>
         </div>
      </div>
   </div>
   <!-- End Dashboard Cards -->

   <!-- Live Feeds (Live Stats / Social Network / Revenue) -->
   <!-- Drawn after the page shows, like the other charts (keeps opening the dashboard fast) -->
   <LiveFeeds v-if="chartsReady" />
   <!-- End Live Feeds -->

   <!-- SmartChat + Birds Eye side by side (one under the other on phones) -->
   <div class="row g-3 mb-4">
      <div class="col-12 col-lg-6">
         <SmartChat />
      </div>
      <div class="col-12 col-lg-6">
         <!-- Drawn after the page shows, like the charts (keeps opening the dashboard fast) -->
         <BirdsEye v-if="chartsReady" />
      </div>
   </div>
   <!-- End SmartChat + Birds Eye -->

   <!-- My Events + ToDo's side by side (one under the other on phones) -->
   <div class="row g-3 mb-4">
      <div class="col-12 col-lg-6">
         <Calendar />
      </div>
      <div class="col-12 col-lg-6">
         <Todos />
      </div>
   </div>
   <!-- End My Events + ToDo's -->

   <!-- Charts 1-->
   <div class="row g-3 mb-4">
      <div class="col-12 col-md-6">
         <div class="card bg-sa-card h-100">
            <div class="card-header bg-sa-card-header">Monthly Sales</div>
            <div class="card-body bg-sa-card-body chart-body">
               <div v-if="chartsReady">
               <apexchart type="bar" height="300" :options="barOptions" :series="barSeries"/>
            </div>
            </div>
         </div>
      </div>
      <div class="col-12 col-md-6">
         <div class="card bg-sa-card h-100">
            <div class="card-header bg-sa-card-header">User Distribution</div>
            <div class="card-body bg-sa-card-body chart-body">
               <div v-if="chartsReady">
               <apexchart type="donut" height="300" :options="pieOptions" :series="pieSeries"/>
            </div>
            </div>
         </div>
      </div>
   </div>
   <!-- End Charts 1-->

   <!-- Charts 2-->
   <div class="row g-3 mb-4">
      <div class="col-12 col-md-6">
         <div class="card bg-sa-card h-100">
            <div class="card-header bg-sa-card-header">Monthly Sales</div>
            <div class="card-body bg-sa-card-body chart-body">
               <div v-if="chartsReady">
               <apexchart type="line" height="300" :options="lineOptions" :series="lineSeries" />
            </div>
            </div>
         </div>
      </div>
      <div class="col-12 col-md-6">
         <div class="card bg-sa-card h-100">
            <div class="card-header bg-sa-card-header">User Distribution</div>
            <div class="card-body bg-sa-card-body chart-body">
               <div v-if="chartsReady">
               <apexchart type="area" height="300" :options="areaOptions" :series="areaSeries" />
            </div>
            </div>
         </div>
      </div>
   </div>
   <!-- End Charts 2-->

   <!-- Charts 3-->
   <div class="row g-3 mb-4">
      <div class="col-12 col-md-6">
         <div class="card bg-sa-card h-100">
            <div class="card-header bg-sa-card-header">Monthly Sales</div>
            <div class="card-body bg-sa-card-body chart-body">
               <div v-if="chartsReady">
               <apexchart type="bar" height="300" :options="hBarOptions" :series="hBarSeries" />
            </div>
            </div>
         </div>
      </div>
      <div class="col-12 col-md-6">
         <div class="card bg-sa-card h-100">
            <div class="card-header bg-sa-card-header">User Distribution</div>
            <div class="card-body bg-sa-card-body chart-body">
               <div v-if="chartsReady">
               <apexchart type="donut" height="300" :options="donutOptions" :series="donutSeries" />
            </div>
            </div>
         </div>
      </div>
   </div>
   <!-- End Charts 3-->

   <!-- Charts 4-->
   <div class="row g-3 mb-4">
      <div class="col-12 col-md-6">
         <div class="card bg-sa-card h-100">
            <div class="card-header bg-sa-card-header">Monthly Sales</div>
            <div class="card-body bg-sa-card-body chart-body">
               <div v-if="chartsReady">
               <apexchart type="pie" height="300" :options="pieOptions" :series="pieSeries" />
            </div>
            </div>
         </div>
      </div>
      <div class="col-12 col-md-6">
         <div class="card bg-sa-card h-100">
            <div class="card-header bg-sa-card-header">User Distribution</div>
            <div class="card-body bg-sa-card-body chart-body">
               <div v-if="chartsReady">
               <apexchart type="radialBar" height="300" :options="radialOptions" :series="radialSeries" />
            </div>
            </div>
         </div>
      </div>
   </div>
   <!-- End Charts 4-->

   <!-- Charts 5-->
   <div class="row g-3 mb-4">
      <div class="col-12 col-md-6">
         <div class="card bg-sa-card h-100">
            <div class="card-header bg-sa-card-header">Monthly Sales</div>
            <div class="card-body bg-sa-card-body chart-body">
               <div v-if="chartsReady">
               <apexchart type="heatmap" height="300" :options="heatOptions" :series="heatSeries" />
            </div>
            </div>
         </div>
      </div>
      <div class="col-12 col-md-6">
         <div class="card bg-sa-card h-100">
            <div class="card-header bg-sa-card-header">User Distribution</div>
            <div class="card-body bg-sa-card-body chart-body">
               <div v-if="chartsReady">
               <apexchart height="300" :options="mixedOptions" :series="mixedSeries" />
            </div>
            </div>
         </div>
      </div>
   </div>
   <!-- End Charts 5-->

   <!-- Charts 5-->
   <div class="row g-3 mb-4">
      <div class="col-12 col-md-6">
         <div class="card bg-sa-card h-100">
            <div class="card-header bg-sa-card-header">Monthly Sales</div>
            <div class="card-body bg-sa-card-body chart-body">
               <div v-if="chartsReady">
               <apexchart type="heatmap" height="300" :options="heatOptions" :series="heatSeries" />
            </div>
            </div>
         </div>
      </div>
      <div class="col-12 col-md-6">
         <div class="card bg-sa-card h-100">
            <div class="card-header bg-sa-card-header">User Distribution</div>
            <div class="card-body bg-sa-card-body chart-body">
               <div v-if="chartsReady">
               <apexchart type="radar" height="300" :options="radarOptions" :series="radarSeries" />
            </div>
            </div>
         </div>
      </div>
   </div>
   <!-- End Charts 5-->
</template>
<script>
import AlertComponent from '../components/ui/AlertComponent.vue';
import Calendar from '../components/admin/Calendar.vue';
import SmartChat from '../components/admin/SmartChat.vue';
import LiveFeeds from '../components/admin/LiveFeeds.vue';
import BirdsEye from '../components/admin/BirdsEye.vue';
import Todos from '../components/admin/Todos.vue';
import axios from 'axios';
import emitter from '../main.js';

export default {
  name: "AllCharts",
  components: { 
   AlertComponent,
   Calendar,
   SmartChat,
   LiveFeeds,
   BirdsEye,
   Todos
  },
  data() {
    return {
      chartsReady: false,
      themeObserver: null,   // watches for skin changes (charts follow the skin)
      switchingCompanyBranch: false,
      tableData: this.getDefaultTableData(),
      defaultAlert: this.getDefaultAlert(),
      /* ================= LINE ================= */
      lineSeries: [{
        name: "Revenue",
        data: [10000, 15000, 13000, 18000, 22000]
      }],
      lineOptions: {
        chart: { type: 'line', animations: { enabled: false }},
        stroke: { curve: 'smooth' },
        xaxis: { categories: ['Jan','Feb','Mar','Apr','May'] }
      },

      /* ================= AREA ================= */
      areaSeries: [{
        name: "Cash Flow",
        data: [5000, 7000, 6000, 9000, 12000]
      }],
      areaOptions: {
        chart: { type: 'area' },
        dataLabels: { enabled: false },
        xaxis: { categories: ['Jan','Feb','Mar','Apr','May'] }
      },

      /* ================= BAR ================= */
      barSeries: [{
        name: "Sales",
        data: [30, 40, 35, 50, 49]
      }],
      barOptions: {
        chart: { type: 'bar' },
        xaxis: { categories: ['Mon','Tue','Wed','Thu','Fri'] }
      },

      /* ================= HORIZONTAL BAR ================= */
      hBarSeries: [{
        name: "Departments",
        data: [44, 55, 41, 67]
      }],
      hBarOptions: {
        chart: { type: 'bar' },
        plotOptions: { bar: { horizontal: true }},
        xaxis: { categories: ['HR','IT','Sales','Finance'] }
      },

      /* ================= DONUT ================= */
      donutSeries: [44, 55, 13, 33],
      donutOptions: {
        labels: ['Marketing','Sales','IT','HR']
      },

      /* ================= PIE ================= */
      pieSeries: [10, 20, 30],
      pieOptions: {
        labels: ['Admins','Managers','Users']
      },

      /* ================= RADIAL KPI ================= */
      radialSeries: [75],
      radialOptions: {
        chart: { type: 'radialBar' },
        plotOptions: {
          radialBar: {
            dataLabels: {
              value: { formatter: val => val + "%" }
            }
          }
        },
        labels: ['Completion']
      },

      /* ================= HEATMAP ================= */
      heatSeries: [{
        name: "Attendance",
        data: [
          { x: 'Mon', y: 90 },
          { x: 'Tue', y: 80 },
          { x: 'Wed', y: 95 },
          { x: 'Thu', y: 70 },
          { x: 'Fri', y: 85 }
        ]
      }],
      heatOptions: {
        chart: { type: 'heatmap' }
      },

      /* ================= MIXED ================= */
      mixedSeries: [
        { name: 'Revenue', type: 'column', data: [30,40,35,50] },
        { name: 'Expenses', type: 'line', data: [20,30,25,40] }
      ],
      mixedOptions: {
        chart: { stacked: false },
        xaxis: { categories: ['Q1','Q2','Q3','Q4'] }
      },

      /* ================= RADAR ================= */
      radarSeries: [{
        name: "Performance",
        data: [80, 50, 30, 40, 100]
      }],
      radarOptions: {
        chart: { type: 'radar' },
        xaxis: {
          categories: ['Sales','Marketing','IT','HR','Finance']
        }
      }
    }
  },
  created() { 
   this.functionForShowOrHideLoader();
  },
  methods: { 
   getDefaultTableData(){
         return {
             //Table Data plus pagination
            records: [],
            currentPage: 1,
            totalPages: 1,
            recordsPerPage: 10,
            searchBy: 'firstname',
            searchQuery: '',
            searchPlaceHolderText: 'Search by firstname',
            responseTime: null,
            startRecord: 0,
            endRecord: 0,
            currentSortColumn: 'id',
            currentSortDirection: 'DESC',
            recordFilter: 'all',
            startDate: '',
            endDate: '',
            selectedRecordId: '',
            deleteType: '', // store the type of delete
            totalRecords: 0,
            isVisible: false,
            loaderMessage: "Loading page...",
            loaderValue: null,
            simulatedProgressInterval: null,
            // ✅ New properties
            selectAll: false, 
            selectedRecordIds: [] 
         }
   },
   getDefaultAlert(){
         return {
            //For Alerts
            alertMessage: "",
            alertstatus: "",
            showAlert: '',
            alertType: "",
            button_text: '',
            pageOrModal: ""
         }
   },
   handleCompanyBranchSwitch() {
       const switchingMessage = sessionStorage.getItem(
           'switching_company_branch'
       );

       if (!switchingMessage) {
           return;
       }

       this.switchingCompanyBranch = true;

       this.$displayAlert(
           "starting",
           switchingMessage,
           "info",
           "page"
       );

       setTimeout(() => {

           this.switchingCompanyBranch = false;

           this.defaultAlert.alertMessage = '';
          this.defaultAlert.alertstatus = '';
          this.defaultAlert.alertType = '';
          this.defaultAlert.pageOrModal = '';

           sessionStorage.removeItem(
               'switching_company_branch'
           );

       }, 1500);
   },
   // Charts follow the skin: text, grid lines, legend and tooltip colours for every chart
   applyChartTheme() {
      const el = document.querySelector('.chart-body') || document.querySelector('.bg-sa-card-body') || document.body;
      const color = getComputedStyle(el).color;
      const [r, g, b] = (color.match(/\d+/g) || [128, 128, 128]).map(Number);
      const darkSkin = (r * 299 + g * 587 + b * 114) / 1000 > 150; // light text = dark skin
      window.Apex = {
         chart: { foreColor: color, background: 'transparent', fontFamily: 'inherit' },
         grid: { borderColor: 'rgba(128,128,128,0.18)' },
         legend: { labels: { colors: color } },
         tooltip: { theme: darkSkin ? 'dark' : 'light' },
      };
   },
   // Skin changed: new colours, then draw the charts again
   redrawChartsForSkin() {
      this.applyChartTheme();
      this.chartsReady = false;
      this.$nextTick(() => { this.chartsReady = true; });
   },
   functionForShowOrHideLoader(){
      this.$showOrHideLoader(this.tableData.loaderMessage);
      setTimeout(() => {
           this.tableData.isVisible = false;
       }, 1000);
   }
  },
   async mounted() { 
      /*after subscribing is successful*/
      const dashboardMessage = sessionStorage.getItem('dashboard_message');
      if (dashboardMessage) {
           this.$displayAlert("starting", dashboardMessage, "primary", "page");
           sessionStorage.removeItem('dashboard_message');
      }
      /*End after subscribing is successful*/

      emitter.on(
           'companyBranchSwitched',
           this.handleCompanyBranchSwitch
       );

      this.handleCompanyBranchSwitch();
       //await this.functionForShowOrHideLoader();
       // Chart colours from the skin before the charts are drawn
       this.applyChartTheme();
       this.themeObserver = new MutationObserver(() => this.$nextTick(this.redrawChartsForSkin));
       this.themeObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme'] });

       this.$nextTick(() => {
           setTimeout(() => {
               this.chartsReady = true;
           }, 100);
       });
  },
  beforeUnmount() {

       if (this.themeObserver) this.themeObserver.disconnect();

       emitter.off(
           'companyBranchSwitched',
           this.handleCompanyBranchSwitch
       );

   },


}
</script>